import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Typography, FormControl, FormControlLabel } from '@mui/material';
import * as types from 'constants/actionTypes';

class ToggleInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value || true,
            name: props.name
        };
    }

    // componentWillReceiveProps(nextProps) {
    //     if (nextProps.value !== this.state.value && nextProps.name === this.state.name) {
    //
    //         this.setState({ value: nextProps.value });
    //     }
    // }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.value !== prevState.value) {
            return { value: nextProps.value };
        }
        return null;
    }
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ value: this.props.value });
        }
    }

    onToggle = (event, value) => {
        this.setState({ value });
        this.props.dispatch({ type: types.FORM_INPUT, value, name: this.props.name });
        if (this.props.onToggle){
            this.props.onToggle(event);
        }
    }

    render() {
        const { name, label, label2, disabled, className, state, labelPlacement, lineBreak, option1 = this.props.option1 || "Inactive", option2 = this.props.option2 || "Active", value } = this.props || {};

        return (
            <FormControl
                fullWidth
                className={`form-group ToggleInput ${lineBreak ? `lineBreak` : ``} ${disabled ? `disabled` : ``}`}
                labelPlacement={labelPlacement}
            >
                {
                    option2 ?
                        <React.Fragment>
                            {label && <label>{label}</label>}
                            <div className="optionArea">
                                <Typography>{option1}</Typography>
                                <Switch
                                    value={value}
                                    id={this.props.id}
                                    checked={this.state.value}
                                    onChange={this.onToggle}
                                    name={name}
                                    disabled={disabled}
                                    disableRipple
                                />
                                <Typography>{option2}</Typography>
                            </div>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <React.Fragment>
                                {label && <label>{label}</label>}
                                <div className="optionArea">
                                    <Switch
                                        value={value}
                                        id={this.props.id}
                                        checked={this.state.value}
                                        onChange={this.onToggle}
                                        name={name}
                                        disabled={disabled}
                                        disableRipple
                                    />
                                </div>
                            </React.Fragment>
                        </React.Fragment>
                }


            </FormControl>
        );
    }

}

const mapStateToProps = (state, props) => {

    return {
        value: state.form[props.name]
    };
};

export default connect(mapStateToProps)(ToggleInput);
